export const CANVAS_WIDTH = 1600
export const CANVAS_HEIGHT = 1000
export const BACKEND_URL = DEFINE_BACKEND_URL //injected through webpack.DefinePlugin
export const hoverList = [
  'box',
  'cover-open',
  'cover-closed',
  'saddle',
  'kickstand',
  'grips',
  'wheels',
  'tires',
  'frame-lock',
  'front-carrier',
  'electric-motor',
  'alubasket',
  'mud-flap',
  'handlebars-and-grips',
  'rear-carrier',
  'front-crate'
]

export const toggleList = [
  'rain-saddle',
  'straps',
  'carrying-handle',
  'toolbag-saddle',
  'toolbag-frame',
  'bottle-holder',
  'name-plate',
  'chain-lock',
  'bottle-front',
  'skirt-guard',
  'basket-cover',
  'gps-tracker',
  'smart-phone-holder',
  'bench',
  'belt',
  'belts',
  'extra-battery'
]

export const isDk = window.location.hostname.endsWith('s.dk')
export const isEu = window.location.hostname.endsWith('s.eu')
export const isDe = window.location.hostname.endsWith('s.de')
